import styled from 'styled-components';
import { FlexibleDiv } from '../../../styled/common';
import { Breakpoints } from '../../../styled/constants';
import { Typography } from '../../ui/Typography';

export const ApartmentsInfoItem = styled(FlexibleDiv)`
  gap: 10px;

  @media (min-width: ${Breakpoints.tablet}px) {
    &:not(:last-child) {
      margin-bottom: 10px;
    }
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    display: flex;
    justify-content: space-between;
    gap: 10px;

    &:not(:last-child) {
      margin: 0;
    }
  }
`;

export const ApartmentsInfoValue = styled(Typography)`
  display: block;
  width: calc(50% - 5px);

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    width: max-content;
  }
`;

export const ApartmentsInfoTitle = styled(ApartmentsInfoValue)`
  color: ${({ theme }) => theme.colors.text.secondary};

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    color: ${({ theme }) => theme.colors.text.primary};
  }
`;
